import { Box, Grid2Props as GridProps, Unstable_Grid2 as Grid } from "@mui/material";
import { ReactNode } from "react";

export interface PageGridProps extends GridProps {
    /**
     * Boolean indicating if the grid is used for a navigation top bar.
     * If true, padding will be set to 0px and item alignment to "center"
     * @default false
     */
    navigation?: boolean;
    /**
     * Boolean indicating if the grid is used for a footer.
     * If true, row spacing and top/bottom padding will be set to 40px
     * @default false
     */
    footer?: boolean;
    /**
     * Max width of the content area (grid) inside the fullwidth container
     */
    maxContentWidth?: string;
    /**
     * Grid items, or other react elements inside the grid container
     */
    children?: ReactNode;
}

/**
 * @deprecated Replaced by SenecPageGrid component
 *
 * `PageGrid` used to structure the content area, header (navigation), or footer of a portal page.
 * It should be used as a base component for portal-specific page grids.
 * Grid items should be MUI Grid v2.
 *
 * - Based on MUI Grid v2: https://mui.com/material-ui/react-grid2/
 * - MUI Spacing based on 8px scaling factor: https://mui.com/material-ui/customization/spacing/
 */
export const PageGrid = (props: PageGridProps) => {
    const { navigation, footer, maxContentWidth, children, ...remainingProps } = props;

    const getPaddingBottom = () => {
        if (navigation) {
            return 2;
        }

        return footer ? 5 : 15;
    };

    const getPaddingTop = () => {
        if (navigation) {
            return 2;
        }

        return footer ? 5 : 7;
    };

    return (
        <Box width="100%">
            <Grid
                container
                columns={{ xs: 6, sm: 8, md: 12 }}
                columnSpacing={{ xs: 2, sm: 3 }}
                rowSpacing={footer ? 5 : 4}
                paddingTop={getPaddingTop()}
                paddingBottom={getPaddingBottom()}
                px={{ xs: 2, sm: 3, md: 10 }}
                alignItems={navigation ? "center" : {}}
                {...remainingProps}
                sx={{
                    maxWidth: maxContentWidth ?? "1920px",
                    marginLeft: "auto",
                    marginRight: "auto",
                    ...props.sx,
                }}
            >
                {children}
            </Grid>
        </Box>
    );
};
